import { render, staticRenderFns } from "./FrequentlyAskeduestions.vue?vue&type=template&id=40089d8e"
import script from "./FrequentlyAskeduestions.vue?vue&type=script&lang=js"
export * from "./FrequentlyAskeduestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports